import React from "react";
import "./Header.css";
import logo from "../../assets/images/image.png";

export default function Header() {
  return (
    <header className="brand-header">
      <div className="brand-container">
        <div className="brand-logo-wrapper">
          <img
            src={logo}
            alt="VS Jewel Cast"
            className="brand-logo-img"
          />
        </div>
      </div>
    </header>
  );
}
